import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './routing/app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { TdsRequestModule } from './features/tds-request/tds-request.module';
import { MsalRedirectComponent } from '@azure/msal-angular';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    TdsRequestModule,
    AppRoutingModule,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule
{
  public constructor()
  {
  }
}